//import PropTypes from 'prop-types'
import { connect } from "react-redux";
import { mixerConnector } from "react-arc";
import config from "../../../../config/config";
import ModelWithAuthContainer from "../../../auth/containers/ModelWithAuthContainer";
import createHOC from "../../../arc/createHOC";

/** DONT FORGET TO :
 [ ] DECLARE YOUR store : config/store.js  -> userFood
 [ ] ADD MODEL REQUIRED PROPS, in configUserFood
 [ ] TYPE THEM  const types = {id: PropType.string.isRequired} (for instance
 [ ] IMPORT ARCModel, createHOC, config (for your urls), from where you are in the project (use your IDE)
 **/

export const USER_BLOCK_NAMESPACE = "USER_FOOD";

export const configUserBlock = {
  name: "userBlock",
  uppercaseName: USER_BLOCK_NAMESPACE,
  modelProps: ["id"],
  collectionProps: [],
  paths: {
    item: config.blocks.block,
    read: config.blocks.block + "/{id}",
    update: config.blocks.block + "/{id}",
    delete: config.blocks.block + "/{id}",
  },
  headers: {
    "Content-Type": "application/json",
    "X-Auth-Token": "{token}",
  },
  fetchOnce: false,
  maxPendingRequestsPerReducer: 3,
  requestFetchDelay: 100,
};

const types = {};

export class UserBlockContainerBase extends ModelWithAuthContainer {
  static defaultProps = {
    ARCConfig: configUserBlock,
  };
  static propTypes = types;
}

const connector = mixerConnector(connect, configUserBlock);
export const UserBlockContainer = connector(UserBlockContainerBase);

const withUserBlock = createHOC({
  Container: UserBlockContainer,
  ARCConfig: configUserBlock,
});
withUserBlock.propTypes = types;

export default withUserBlock;
